import { render, staticRenderFns } from "./GroupVisitTable.vue?vue&type=template&id=42ec39c2&scoped=true"
import script from "./GroupVisitTable.vue?vue&type=script&lang=js"
export * from "./GroupVisitTable.vue?vue&type=script&lang=js"
import style0 from "./GroupVisitTable.vue?vue&type=style&index=0&id=42ec39c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec39c2",
  null
  
)

export default component.exports